import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { format, formatDistanceToNow, parseISO } from "date-fns";
import { it } from "date-fns/locale";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return "-";
  try {
    const date = parseISO(dateString);
    return format(date, "dd/MM/yyyy HH:mm", { locale: it });
  } catch {
    return "-";
  }
}

export function formatDateShort(dateString) {
  if (!dateString) return "-";
  try {
    const date = parseISO(dateString);
    return format(date, "dd/MM/yyyy", { locale: it });
  } catch {
    return "-";
  }
}

export function formatRelativeTime(dateString) {
  if (!dateString) return "-";
  try {
    const date = parseISO(dateString);
    return formatDistanceToNow(date, { addSuffix: true, locale: it });
  } catch {
    return "-";
  }
}

export function getOpenRateBadgeColor(rate) {
  if (rate < 20) return "danger";
  if (rate < 50) return "warning";
  return "success";
}

export function getDeviceIcon(device) {
  switch (device?.toLowerCase()) {
    case "mobile":
      return "Smartphone";
    case "tablet":
      return "Tablet";
    case "desktop":
    default:
      return "Monitor";
  }
}

export function getCountryFlag(countryCode) {
  if (!countryCode) return "";
  const codePoints = countryCode
    .toUpperCase()
    .split("")
    .map((char) => 127397 + char.charCodeAt());
  return String.fromCodePoint(...codePoints);
}

export function truncateUrl(url, maxLength = 40) {
  if (!url) return "";
  if (url.length <= maxLength) return url;
  return url.substring(0, maxLength) + "...";
}

export function copyToClipboard(text) {
  return navigator.clipboard.writeText(text);
}

export const BASE_URL = "https://tracking.maxvalle.app/api";
